import { RefObject, useEffect, useState } from 'react'

const useNodeWidth = (ref: RefObject<HTMLElement>): number => {
    const [width, setWidth] = useState<number>(0)

    useEffect(() => {
        if (!ref.current) return

        const callback = () => {
            if (!ref.current) return

            setWidth(ref.current.offsetWidth)
        }

        const mutations = new MutationObserver(callback)

        mutations.observe(ref.current, { attributes: true })
        callback()

        return () => {
            mutations.disconnect()
        }
    }, [ref.current])

    return width
}

export default useNodeWidth